import { prop } from 'ramda'

export const share = prop('share')
export const config = prop('config')
export const episode = prop('episode')
export const origin = prop('origin')
